module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_feb_02-67f657e1dfc8b393e6bb31e73b6c989d.png";